export const OrderWizardSteps = {
  PACKAGE_SELECTOR: 0,
  VEHICLE_REGISTRATION: 1,
  CONTRACT_INPUT: 2,
  PAYMENT: 3,
  THANKS: 4
}
